if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();

        // React to colour/colour changes (capture; no pub/sub required)
        // AMC EDIT "VARIANT COLOUR PICKER IMAGES" - Remove if problems
        // Remember last selected color
        this.lastColor = null;

        // Listen for color/colour changes
        document.addEventListener(
          'change',
          (e) => {
            console.log("event: change")
            const t = e.target;
            if (!t) return;
            const vs = t.closest && t.closest('variant-selects');
            if (!vs) return;

            const inputOrOption = t.tagName === 'SELECT' ? (t.selectedOptions && t.selectedOptions[0]) : t;
            const rawName = t.name || (t.closest && t.closest('select')?.name) || '';
            const name = (rawName || '').trim().toLowerCase();
            const isColor = name.includes('color') || name.includes('colour');
            if (!isColor) return;

            const color = inputOrOption?.value;
            if (!color) return;

            const sectionIdFromEvent = vs?.dataset?.section;
            const mySectionId = this.id?.replace('MediaGallery-', '');
            if (sectionIdFromEvent && mySectionId && sectionIdFromEvent !== mySectionId) return;

            this.filterByColor(color);
          },
          true
        );

        // Re-apply filter after slider/DOM refreshes
        //const reapply = debounce(() => {
          //if (this.lastColor) this.filterByColor(this.lastColor, { silent: true });
        //}, 100);

        // Observe DOM changes within viewer (slider may rebuild)
        //if (this.elements.viewer) {
        //  this._observer = new MutationObserver(reapply);
        //  this._observer.observe(this.elements.viewer, { childList: true, subtree: true });
        //}

        // Handle section reloads and responsive re-inits
        //document.addEventListener('shopify:section:load', (e) => {
        //  const mySectionId = this.id?.replace('MediaGallery-', '');
        //  if (e?.detail?.sectionId && e.detail.sectionId === mySectionId) reapply();
        //});
        //window.addEventListener('resize', debounce(reapply, 150));

        // Optional: initial filter on load for the currently checked colour
        document.addEventListener('DOMContentLoaded', () => {
          console.log("dom ass")
          const vs = this.closest && this.closest('section')?.querySelector('variant-selects');
          const mySectionId = this.id?.replace('MediaGallery-', '');
          if (!vs || (vs.dataset?.section && vs.dataset.section !== mySectionId)) return;

          const checkedColorInput = Array.from(vs.querySelectorAll('input[type="radio"]')).find(
            (i) => i.checked && (i.name || '').toLowerCase().includes('color') || (i.name || '').toLowerCase().includes('colour')
          );
          const color = checkedColorInput?.value;
          if (color) this.filterByColor(color);
        });
        // END AMC EDIT "VARIANT COLOUR PICKER IMAGES" - Remove if problems
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }

      // AMC EDIT "VARIANT COLOUR PICKER IMAGES" - Remove if problems
      normalize(str) {
        return (str || '').toLowerCase().replace(/\s+/g, ' ').trim();
      }

      colorAliases(color) {
        // Generate ["off-white", "off white", "offwhite"] and de-duplicate
        const base = this.normalize(color);
        const hyphen = base.replace(/\s+/g, '-');
        const spaced = base.replace(/-+/g, ' ');
        const collapsed = base.replace(/[\s-]+/g, '');
        const variants = [base, hyphen, spaced, collapsed];
        return Array.from(new Set(variants));
      }

      altMatchesColor(alt, color) {
        const hay = this.normalize(alt || '');
        const needles = this.colorAliases(color);
        return needles.some((needle) => needle && hay.includes(needle));
      }

      getItemAlt(rootEl) {
        const img =
          rootEl.querySelector('.product__media img') ||
          rootEl.querySelector('.deferred-media__poster img') ||
          rootEl.querySelector('img');
        return img?.getAttribute('alt') || '';
      }

      filterByColor(color, opts = {}) {
        console.log({ last: this.lastColor, color })
        if(color === this.lastColor) { 
          return 
        } else { 
          this.lastColor = color
        }
        console.log("filtering", { last: this.lastColor, color })
        const slides = this.elements.viewer
          ? this.elements.viewer.querySelectorAll('ul[id^="Slider-Gallery"] > li.product__media-item[data-media-id]')
          : [];

        const thumbs = this.elements.thumbnails
          ? this.elements.thumbnails.querySelectorAll('ul[id^="Slider-Thumbnails"] > li.thumbnail-list__item[data-target]')
          : [];

        let firstMatchMediaId = null;

        // Filter slides by alt text (case-insensitive, hyphen/space tolerant)
        slides.forEach((li) => {
          const alt = this.getItemAlt(li);
          const show = this.altMatchesColor(alt, color);
          li.style.display = show ? '' : 'none';
          li.dataset.filterHidden = show ? 'false' : 'true';
          if (show && !firstMatchMediaId) firstMatchMediaId = li.getAttribute('data-media-id');
        });

        // Filter thumbnails similarly
        thumbs.forEach((li) => {
          const alt = this.getItemAlt(li);
          const show = this.altMatchesColor(alt, color);
          li.style.display = show ? '' : 'none';
          li.dataset.filterHidden = show ? 'false' : 'true';
        });

        // Visible slides
        const visibleSlides = Array.from(slides).filter((li) => li.style.display !== 'none');

        // If nothing matched, restore all and counters
        if (visibleSlides.length === 0) {
          slides.forEach((li) => { li.style.display = ''; li.dataset.filterHidden = 'false'; });
          thumbs.forEach((li) => { li.style.display = ''; li.dataset.filterHidden = 'false'; });
          this.updateSliderCounter();
          return;
        }

        // Ensure an active visible slide
        const active = this.elements.viewer.querySelector('ul[id^="Slider-Gallery"] > li.product__media-item.is-active');
        const activeHidden = !active || active.style.display === 'none';
        if (activeHidden && firstMatchMediaId && !opts.silent) {
          this.setActiveMedia(firstMatchMediaId, true);
        }

        // Reflow slider if available
        //if (this.elements.viewer?.slider) this.elements.viewer.resetPages?.();

        // Update counter
        this.updateSliderCounter();
      }

      updateSliderCounter() {
        console.log("slider counter")
        const counter = this.elements.viewer?.querySelector('.slider-counter');
        if (!counter) return;

        const totalEl = counter.querySelector('.slider-counter--total');
        const currentEl = counter.querySelector('.slider-counter--current');
        if (!totalEl || !currentEl) return;

        const slides = this.elements.viewer.querySelectorAll('ul[id^="Slider-Gallery"] > li.product__media-item[data-media-id]');
        const visibleSlides = Array.from(slides).filter((li) => li.style.display !== 'none');

        totalEl.textContent = String(visibleSlides.length || slides.length);

        const active = this.elements.viewer.querySelector('ul[id^="Slider-Gallery"] > li.product__media-item.is-active');
        let currentIndex = 1;
        if (active) {
          const idx = visibleSlides.indexOf(active);
          currentIndex = idx >= 0 ? idx + 1 : 1;
        }
        currentEl.textContent = String(currentIndex);
      }
      // END AMC EDIT "VARIANT COLOUR PICKER IMAGES" - Remove if problems
    }
  );
}
